<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'GLOBAL.CANCEL' | translate }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="formGroup">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="form-group">
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>{{ 'TASK.CANCEL_REASON' | translate }}</mat-label>
              <textarea matInput rows="5" formControlName="reason"></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-label>{{ 'TASK.CANCEL_PROMPT' | translate }}&nbsp;</mat-label>
            <mat-radio-group formControlName="confirmation">
              <mat-radio-button value="yes">Yes</mat-radio-button>
              <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            color="secondary"
            mat-button
            (click)="onNoClick()"
            [disabled]="viewLoading"
          >
            Cancel</button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            mat-button
            (click)="onSubmit()"
            color="warn"
            [disabled]="viewLoading || formGroup.controls.confirmation.value !== 'yes'"
          >
            {{ 'Ok' }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
